import { OperationTypeNode } from 'graphql';
import { ApolloLink, makeVar } from '~/lazy_apollo/client';
import { getOperationDefinition } from '~/lazy_apollo/client/utilities';

export const mutationCompletedAtVar = /* @__PURE__ */ makeVar<Record<string, string>>({});

export const mutationCompletedAtLink = new ApolloLink((operation, forward) => {
  if (getOperationDefinition(operation.query)?.operation !== OperationTypeNode.MUTATION) {
    return forward(operation);
  }

  return forward(operation).map((result) => {
    if (!result.errors?.length) {
      mutationCompletedAtVar({ ...mutationCompletedAtVar(), [operation.operationName]: new Date().toISOString() });
    }
    return result;
  });
});
